// extracted by mini-css-extract-plugin
export default {"services":"_services_services__Pb2fU","headphonesIcon":"_services_headphonesIcon__cQoM6"};